<template>
  <div :class="$style.zufallsTeaser">
    <div v-if="manualteaser[randomNumber]" :class="$style.randomManualTeaser">

      <div v-if="manualteaser[randomNumber].manualteaserRef" :class="$style.imageContainer">
        <a
          :href="getLink(manualteaser[randomNumber].manualteaserRef)"
          target="_blank"
        >
          <img
            v-if="manualteaser[randomNumber].images && manualteaser[randomNumber].images.standard"
            :alt="manualteaser[randomNumber].manualteaserPictureAltText ? manualteaser[randomNumber].manualteaserPictureAltText : ''"
            :src="getImgUrl(manualteaser[randomNumber].images.standard)"
          />
          <img
            v-else
            :alt="manualteaser[randomNumber].manualteaserPictureAltText ? manualteaser[randomNumber].manualteaserPictureAltText : ''"
            src="https://www.rbb888.de/content/dam/rbb/ach/themen/ausflugstipps_meta.jpg.jpg/size=640x360.jpg"
          />
        </a>
      </div>
      
      <div v-else :class="$style.imageContainer">
        <img
          v-if="manualteaser[randomNumber].images && manualteaser[randomNumber].images.standard"
          :alt="manualteaser[randomNumber].manualteaserPictureAltText ? manualteaser[randomNumber].manualteaserPictureAltText : ''"
          :src="getImgUrl(manualteaser[randomNumber].images.standard)"
        />
        <img
          v-else
          :alt="manualteaser[randomNumber].manualteaserPictureAltText ? manualteaser[randomNumber].manualteaserPictureAltText : ''"
          src="https://www.rbb888.de/content/dam/rbb/ach/themen/ausflugstipps_meta.jpg.jpg/size=640x360.jpg"
        />
      </div>

      <div :class="$style.textContainer">
        <div v-if="manualteaser[randomNumber].manualteaserRoofLine" :class="$style.label">
          <span :class="$style.randomManualteaserRoofLine">{{
            manualteaser[randomNumber].manualteaserRoofLine
          }}</span>
        </div>
        <h3 v-if="manualteaser[randomNumber].manualteaserRef">
          <a  
            :href="getLink(manualteaser[randomNumber].manualteaserRef)"
            target="_blank"
          >
            <span :class="$style.manualteasertitle">
              {{ manualteaser[randomNumber].manualteaserTitle }}
            </span>
          </a>
        </h3>
        <h3 v-else>
          <span :class="$style.manualteasertitle">
             {{ manualteaser[randomNumber].manualteaserTitle }}
          </span>
        </h3>

        <p
          :class="$style.randomManualteaserShortText"
          v-html="manualteaser[randomNumber].manualteaserShortText"
        ></p>
        <div :class="$style.buttonContainer">
          <div
            @click="dice"
            role="button"
            alt="Lass den Zufall entscheiden"
            tabindex="0"
            id="spinnerContainer"
            v-on:keyup.enter="dice"
            v-if="showButton"
            :class="$style.btn"
          >
            <font-awesome-icon icon="dice" id="spinner" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "ZufallsTeaser",
  data() {
    return {
      manualteaser: [],
      randomNumber: 0,
      clicked: false,
      showButton: false
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const URL =
        "https://www.rbb888.de/service/gut-leben-in-berlin/ausflugstipps/spaziergaenge.cq5fwk.jsn.jsn";

      const response = await fetch(URL);
      const data = await response.json();
      this.manualteaser = data.middleColumnList.teaserbox[0].manualteaser;
      setTimeout(this.displayButton, 200);
    },
    displayButton() {
      this.showButton = true
      return
    },
    getImgUrl(source) {
      return `https://www.rbb888.de${source}`;
    },
    getLink(source) {
      if (!source) return;
      return `https://www.rbb888.de${source}.html`;
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    setNumber() {
      const oldNumber = this.randomNumber;
      let newNumber = this.getRandomInt(1, this.manualteaser.length - 1);
      if (oldNumber == newNumber) {
        newNumber = (newNumber += 1) % (this.manualteaser.length - 1);
        if (newNumber == 0) this.getRandomInt(1, this.manualteaser.length - 1);
      }
      this.randomNumber = newNumber;
      this.clicked = false;
      return;
    },
    dice() {
      $("#spinnerContainer").css("outline", "unset");
      if (!this.clicked) {
        this.clicked = true;
        $("#spinner").addClass("zufallsTeaser-fa-spinner");
        setTimeout(function () {
          $("#spinner").removeClass("zufallsTeaser-fa-spinner");
        }, 2200);
        setTimeout(this.setNumber, 2200);
      }
    },
  },
};
</script>

<style lang="scss" module>
h3 {
  margin-block-end: 0;
  margin-block-start: 10px;
  margin-bottom: 11px;
}

a {
  text-decoration: none;

  :hover {
    text-decoration: underline;
    color: #007f82;
  }
}

.randomManualTeaser {
  margin-bottom: 15px;
  text-align: left;
  display: flex;
  position: relative;

  .textContainer {
    display: flex;
    flex-direction: column;
    padding-left: 15px;
    padding-top: unset;
    flex: 1;
    font-family: "Interstate", Tahoma, Arial, sans-serif;
    line-height: 1.4286em;

    .label {
      margin-top: 3px;
    }

    .manualteasertitle {
      color: #007f82;
      font-size: 24px;
      line-height: 1.0667em;
      font-weight: 400;
    }

    .randomManualteaserRoofLine {
      color: #007f82;
      padding: 5px;
      background-color: white;
      margin-bottom: 1px;
      font-family: inherit;
      font-size: 13px;
      font-style: normal;
      line-height: 1.3846em;
      text-decoration: none;
      border: 1px solid #007f82;
    }

    .randomManualteaserShortText {
      font-size: 14px;
      // margin-block-start: 0;
    }

    .buttonContainer {
      display: flex;
      justify-content: flex-end;

      .btn {
        height: 70px;
        line-height: 70px;
        width: 70px;
        font-size: 2em;
        font-weight: bold;
        border-radius: 50%;
        background-color: #007f82;
        color: white;
        text-align: center;
        cursor: pointer;
        margin-bottom: 4px;
        opacity: 0.8;

        position: absolute;
        bottom: 0px;
      }
    }
  }

  .imageContainer {
    flex: 1;

    img {
      max-width: 100%;
      height: auto;
    }
  }
}

.randomManualTeaser[max-width~="800px"] {
  flex-direction: column !important;

  .textContainer {
    padding-left: unset !important;
    padding-top: 15px !important;
  }

  img {
    width: 100% !important;
  }

  .randomManualteaserShortText {
    margin-bottom: 10px !important;
  }

  .btn {
    position: unset !important;
  }
}

@media screen and (max-width: 800px) {
  .randomManualTeaser {
    flex-direction: column;

    .textContainer {
      padding-left: unset;
      padding-top: 15px;
    }

    img {
      width: 100%;
    }

    .randomManualteaserShortText {
      margin-bottom: 10px;
    }

    .btn {
      position: unset !important;
    }
  }
}

</style>
